'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414 from "./presto.-Dashboard-View$$anon$14.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024 from "./presto.types$-Dashboard-Host-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$13() {
  this.aKd = null;
  this.aK5 = null;
  this.aK6 = false;
  this.aKe = null;
  this.aKf = false;
  this.aKi = null;
  this.aKb = null;
  this.aKc = false;
  this.aK7 = null;
  this.aK8 = false;
  this.aK9 = null;
  this.aKa = false;
  this.aKg = false;
  this.aKh = false;
  this.aKd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKi = "DashboardHostStats";
}
export { $c_Lpresto_DashboardView$$anon$13 as $c_Lpresto_DashboardView$$anon$13 };
$p = $c_Lpresto_DashboardView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$13;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$13() {
}
export { $h_Lpresto_DashboardView$$anon$13 as $h_Lpresto_DashboardView$$anon$13 };
$h_Lpresto_DashboardView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aKd;
});
$p.M = (function() {
  if ((!this.aK6)) {
    this.aK5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aK6 = true;
  }
  return this.aK5;
});
$p.O = (function() {
  if ((!this.aKf)) {
    this.aKe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKf = true;
  }
  return this.aKe;
});
$p.D = (function() {
  return this.aKi;
});
$p.t = (function() {
  if ((!this.aKc)) {
    this.aKb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("errors", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("parcel", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aKc = true;
  }
  return this.aKb;
});
$p.N = (function() {
  if ((!this.aK8)) {
    this.aK7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().vm(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().of, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().of, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aK8 = true;
  }
  return this.aK7;
});
$p.Q = (function() {
  if ((!this.aKa)) {
    this.aK9 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414.$c_Lpresto_DashboardView$$anon$14();
    this.aKa = true;
  }
  return this.aK9;
});
$p.v = (function() {
  if ((!this.aKh)) {
    this.aKg = false;
    this.aKh = true;
  }
  return this.aKg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee52) => ((p) => \u03b4scrutinee52.cHp(p)))($j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024.$m_Lpresto_types$DashboardHostStats$())));
});
var $d_Lpresto_DashboardView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$13, "presto.DashboardView$$anon$13", ({
  GN: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$13 as $d_Lpresto_DashboardView$$anon$13 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$13.js.map
